import { createBrowserRouter, Route, RouterProvider, } from "react-router-dom";

import Footer from "./component/Footer";
import Header from "./component/Header";
import Hero from "./component/Hero";
import Adver from "./component/pages/Adver";
import Contact from "./component/pages/Contact";
import Quates from "./component/Quates";
import Question from "./component/Question";


function App() {

  return (
    <>
      <div className="">
        <Header />
        <Footer />
        
      </div>
    </>
  );
}

export default App;
